var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.$branding.isPriceOffer && _vm.availableLocales.length > 1 && !_vm.isUserLoggedIn
  )?_c('NavBarItem',{staticClass:"locale-selector-item",attrs:{"id":"locale-selector","icon":_vm.currentFlagIcon,"icon-pack":"flags","text":_vm.currentLocaleName,"items":_vm.localeMenuItems,"is-last":true,"type":_vm.type}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }